module.exports = __webpack_public_path__ + "img/Button_GooglePlayEnabled.415f1872.png";